<template>
  <div class="istatistics">
    <div class="content_wrapper">
      <div style="padding: 10px;">
        <el-date-picker
          v-model="selectDate"
          style="width:450px"
          type="daterange"
          align="right"
          unlink-panels
          :clearable='false'
          value-format="yyyy-MM-dd"
          range-separator="至"
          @change="changeDate"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </div>
      <div style="padding: 10px;height: calc(100% - 180px)">
        <el-row>
          <el-radio-group v-model="id" @change="view" size="small">
            <el-radio-button label="0">全部接口</el-radio-button>
            <el-radio-button label="1">通用接口</el-radio-button>

            <el-radio-button label="26">questionV4接口</el-radio-button>
            <el-radio-button label="27">questionV4调用总量</el-radio-button>
            <el-radio-button label="28">questionV4去重调用</el-radio-button>
            <el-radio-button label="2">题库类接口</el-radio-button>
            <el-radio-button label="6">试题调用总量</el-radio-button>
            <el-radio-button label="8">试题去重调用</el-radio-button>

            <el-radio-button label="4">文档资源类接口</el-radio-button>
            <el-radio-button label="10">文档总下载</el-radio-button>
            <el-radio-button label="12">文档去重总下载</el-radio-button>

            <el-radio-button label="20">试卷资源类接口</el-radio-button>
            <el-radio-button label="21">试卷总下载</el-radio-button>
            <el-radio-button label="22">试卷去重总下载</el-radio-button>

            <el-radio-button label="23">专辑资源类接口</el-radio-button>
            <el-radio-button label="24">专辑总下载</el-radio-button>
            <el-radio-button label="25">专辑去重总下载</el-radio-button>

            <el-radio-button label="17">微课资源类接口</el-radio-button>
            <el-radio-button label="18">微课总下载</el-radio-button>
            <el-radio-button label="19">微课去重总下载</el-radio-button>
          </el-radio-group>
        </el-row>
        <div class="show_total" style="margin-top:20px;">
          <span>{{showTotal}}</span>
        </div>
        <div class="nodata" v-if="nodata">暂未调用该类型接口</div>
        <div v-show="!nodata" id="myChart" v-loading="loading" :style="{width: '100%', height: '95%'}"></div>
      </div>
    </div>
  </div>
</template>
<script type="text/babel">
import statisticsService from '@/service/statisticsService'
export default {

  data () {
    return {
      selectDate: [],
      showTotal: '',
      id: 0,
      loading: false,
      nodata: false
    }
  },
  mounted () {
    //      this.drawLine();
    let toDate = new Date().Format(this.SysConstant.DATE_FORMATE)
    let fromDate = this.$util.getLast(-6)
    this.selectDate = [fromDate, toDate]
    this.view(this.id)
  },
  methods: {
    async changeDate (dates) {
      await this.view()
    },
    async view () {
      this.loading = true
      let params = {
        fromDate: this.selectDate[0],
        toDate: this.selectDate[1]
      }
      try {
        let data = []
        this.showTotal = ''
        let chartData = {
          x: [],
          y: []
        }
        switch (parseInt(this.id)) {
          case 0:
            data = await statisticsService.fetchAllData(params)
            break
          case 1:
            data = await statisticsService.fetchCommonData(params)
            break
          case 2:
            data = await statisticsService.fetchQuestionData({
              fromDate: params.fromDate,
              toDate: params.toDate,
              resourceType: 1
            })
            if (data && data.questionCount && data.questionCount.itemList) {
              for (let item of data.questionCount.itemList) {
                chartData.x.push(item.localDate)
                chartData.y.push(item.count)
              }
            }
            break
          case 3:
            data = await statisticsService.fetchQuestionData({
              fromDate: params.fromDate,
              toDate: params.toDate,
              resourceType: 2
            })
            if (data && data.questionCount && data.questionCount.itemList) {
              for (let item of data.questionCount.itemList) {
                chartData.x.push(item.localDate)
                chartData.y.push(item.count)
              }
            }
            break
          case 4:
            data = await statisticsService.fetchDocData({
              fromDate: params.fromDate,
              toDate: params.toDate,
              resourceType: 1
            })
            break
          case 5:
            data = await statisticsService.fetchDocData({
              fromDate: params.fromDate,
              toDate: params.toDate,
              resourceType: 2
            })
            break
          case 6:
            data = await statisticsService.fetchDetailData({
              fromDate: params.fromDate,
              toDate: params.toDate,
              resourceType: 1
            })
            break
          case 7:
            data = await statisticsService.fetchDetailData({
              fromDate: params.fromDate,
              toDate: params.toDate,
              resourceType: 2
            })
            break
          case 8:
            data = await statisticsService.fetchDistinctData({
              fromDate: params.fromDate,
              toDate: params.toDate,
              resourceType: 1
            })
            break
          case 9:
            data = await statisticsService.fetchDistinctData({
              fromDate: params.fromDate,
              toDate: params.toDate,
              resourceType: 2
            })
            break
          case 10:
            data = await statisticsService.fetchDownloadData({
              fromDate: params.fromDate,
              toDate: params.toDate,
              resourceType: 1
            })
            break
          case 11:
            data = await statisticsService.fetchDownloadData({
              fromDate: params.fromDate,
              toDate: params.toDate,
              resourceType: 2
            })
            break
          case 12:
            data = await statisticsService.fetchDownloadDistinctData({
              fromDate: params.fromDate,
              toDate: params.toDate,
              resourceType: 1
            })
            break
          case 13:
            data = await statisticsService.fetchDownloadDistinctData({
              fromDate: params.fromDate,
              toDate: params.toDate,
              resourceType: 2
            })
            break
          case 14:
            data = await statisticsService.fetchEliteSchoolDOCData(params)
            break
          case 15:
            data = await statisticsService.fetchEliteSchoolData(params)
            break
          case 16:
            data = await statisticsService.fetchEliteSchoolDistinctData(params)
            break
          case 17:
            data = await statisticsService.fetchMicroClassDOCData(params)
            break
          case 18:
            data = await statisticsService.fetchMicroClassData(params)
            break
          case 19:
            data = await statisticsService.fetchMicroClassDistinctData(params)
            break
          case 20:
            data = await statisticsService.fetchShijuanAPIData(params)
            break
          case 21:
            data = await statisticsService.fetchShijuanDOCData(params)
            break
          case 22:
            data = await statisticsService.fetchShijuanDistinctDOCData(params)
            break
          case 23:
            data = await statisticsService.fetchAlbumAPIData(params)
            break
          case 24:
            data = await statisticsService.fetchAlbumDOCData(params)
            break
          case 25:
            data = await statisticsService.fetchAlbumDistinctDOCData(params)
            break
          case 26:
            data = await statisticsService.fetchQuestionV4Data(params)
            break
          case 27:
            data = await statisticsService.fetchQuestionV4DetailData(params)
            break
          case 28:
            data = await statisticsService.fetchQuestionV4DistinctData(params)
            break
        }
        if (data && data.itemList) {
          for (let item of data.itemList) {
            chartData.x.push(item.localDate)
            chartData.y.push(item.count)
          }
          this.showTotal = '调用次数：' + data.count
          this.nodata = false

          this.$nextTick(()=>{
            this.drawLine(chartData)
          })
        } else {
          this.showTotal = '调用次数：0'
          this.nodata = true
        }
      } catch (e) {
        this.$message.error(e && e.msg)
      }
      this.loading = false
    },
    drawLine (chartData) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('myChart'))
      let option = {
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          data: chartData.x
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: chartData.y,
          type: 'line'
        }]
      }
      // 绘制图表
      myChart.setOption(option)
    }
  }
}
</script>
<style scoped>
  .istatistics {
    padding: 15px 10px;
    height: 100%;
  }
  .istatistics .content_wrapper{
    padding-left: 20px;
    padding-right: 10px;
    background-color: #ffffff;
    padding-top: 30px;
    height: 100%;
  }
  .istatistics .content_wrapper .show_total {
    height: 40px;
    background-color: #F3F5F8;
    line-height: 40px;
    margin-top: 5px;
    color: #333333;
    font-weight: bold;
  }
  .istatistics .content_wrapper .show_total span {
    margin-left: 30px;
  }
  .istatistics .nodata{
    width: 100%;
    height: 200px;
    text-align: center;
    line-height: 200px;
  }
</style>
<style type="text/css">

</style>



// WEBPACK FOOTER //
// src/pages/admin/istatistics/index.vue